import { Form, Col } from "react-bootstrap";
import RATooltip from "./RATooltip";

export default function WeeksPicker({ formData, setFormData, name, inputOnly = false }) {
    const weeksOptions = Array.from({ length: 52 }, (_, i) => i + 1);

    if (!formData.number_weeks && !formData.weeks) {
        setFormData({
            ...formData,
            number_weeks: 3,
            weeks: 3,
        });
    }

    const input = (
        <Form.Group as={Col} className="col-12 col-xl">
            <Col>
                <Form.Select
                    id={`${name}-weeks-selector`}
                    className="d-inline-block px-2"
                    value={formData.number_weeks || formData.weeks}
                    onChange={e =>
                        setFormData({
                            ...formData,
                            number_weeks: e.target.value,
                            weeks: e.target.value,
                        })
                    }>
                    {weeksOptions.map(week => (
                        <option key={week} value={week}>
                            {week} {week === 1 ? "week" : "weeks"}
                        </option>
                    ))}
                </Form.Select>
            </Col>
        </Form.Group>
    );

    if (inputOnly) {
        return input;
    }
    return (
        <div className={`col-xl-${name.toLowerCase().includes("edit") ? 4 : 2}`}>
            <Form.Label className=" text-nowrap">
                Weeks
                <RATooltip className="ms-2">
                    <p>Number of weeks of data used for calculation.</p>
                </RATooltip>
            </Form.Label>
            {input}
        </div>
    );
}
